export default "__VITE_ASSET__B1e$xR88__"